

<template>
  <!-- Delivery Area Start -->
  <section class="delivery_area">
    <img src="../assets/img/shape_10.png" alt="shape" class="shape_10">
    <img src="../assets/img/shape_11.png" alt="shape" class="shape_11">
    <img src="../assets/img/shape_12.png" alt="shape" class="shape_12">
    <img src="../assets/img/shape_13.png" alt="shape" class="shape_13">
    <img src="../assets/img/shape_14.png" alt="shape" class="shape_14">
    <img src="../assets/img/shape_15.png" alt="shape" class="shape_15">
    <img src="../assets/img/shape_16.png" alt="shape" class="shape_16">
    <div class="container">
      <div class="row">
        <div class="col-md-6">
          <div class="delivery_left">
            <img src="../assets/img/delivery_bike.png" alt="img"/>
          </div>
        </div>
        <div class="col-md-6">
          <div class="delivery_right">
            <div class="site_heading">
              <h3 class="sub_title">Free Delivery</h3>
              <h2 class="section_title">Delivered On Right<br> Time & Place</h2>
              <img src="../assets/img/section_delimiter.png" alt="img" class="section_devider">
            </div>
            <p>perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem
              aperiam, eaque ipsa</p>
            <div class="order_box d-lg-flex align-items-center">
              <span class="order-img"><img src="../assets/img/telephone.svg" alt="img"></span>
              <div class="order-content">
                <p>delivery order num.</p>
                <span>123-59794069</span>
              </div>
              <router-link to="/shop/products"><i class="fas fa-shopping-cart"></i> Order Now</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- Delivery Area End -->
</template>
<script>
import {TimelineMax} from "gsap";

export default {
  name: 'DeliveryArea',
  mounted() {
    this.setScene()
  },
  methods: {
    setScene() {
      let self = this;

      // Declare Scene
      const scene = this.$scrollmagic.scene(self.sceneElem(".delivery_area", "100%", "-300"))
        // Declaration of animation and attaching to element
        .setTween(self.getTimeLine(".delivery_left", 1, {
          x: "-300",
          ease: "Linear.easeNone"
        }));

      // Add Scene to controller
      this.$scrollmagic.addScene(scene);
    },
    sceneElem(triggerElem, duration, offset) {
      return {
        triggerElement: triggerElem,
        duration: duration,
        offset: offset
      }
    },
    getTimeLine(triggerElem, duration, edgeObj) {
      return new TimelineMax()
        .from(triggerElem, duration, edgeObj);
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/DeliveryArea.vue